<template>
  <v-row>
    <v-col>
      <v-list>
        <v-list-group
          :value=false
          prepend-icon="mdi-folder"
        >
          <template v-slot:activator>
            <v-list-item-title class="text-start">{{ title }}</v-list-item-title>
          </template>
          <v-list-item v-for='element in elements' :key='element.id'>
            <a v-if='add_locale' :href='element.url + "?locale=" + $i18n.locale' target="_blank">{{ element.file_name }}</a>
            <a v-else :href='element.url' target="_blank">{{ element.file_name }}</a>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-col>
  </v-row>

</template>

<script>
export default {
  name: "DropdownUrl",
  props: {
    title: {
      type: String,
      required: true
    },
    elements: {
      type: Object,
      required: true
    },
    add_locale: {
      type: Boolean,
      default: false
    }
  }
}
</script>
